import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img from "./img/img.png";

export const PlanIsNowTailored = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>Great! Your plan is now tailored to your level </h4>
          <p className={styles.description}>
            We make your walking plan match your activity level and the pace at
            which you aim to achieve your goals.
          </p>
          <p className={styles.descriptionStrong}>
            Take the first step — walking regularly supports your weight loss
            goal.
          </p>
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
